<div class="title-row field-group mt-2" fxLayout="row" fxLayoutAlign="space-between center">
  <main class="title-simple-steps">
    <h1>{{ titleKey | translate }}</h1>
    <p *ngIf="descriptionKey" class="step-description">
      {{ descriptionKey | translate }}
    </p>
  </main>
</div>

<form class="sign-up-form">
  <div class="add-services-container" fxLayout="column" fxLayoutAlign="start stretch">
    <mat-tab-group
      *ngIf="businessTypes?.length"
      (selectedIndexChange)="onTabChange($event)"
      class="business-type-tabs"
    >
      <mat-tab
        *ngFor="let bt of businessTypes"
        [label]="bt.GlobalName"
      >
      </mat-tab>
    </mat-tab-group>
  
    <div class="services-section" *ngIf="currentBusinessTypeSelected">
      <div
        class="select-all-row"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
      >
        <div class="bt-1">
          <mat-checkbox
            class="terms-conditions"
            color="primary"
            [(ngModel)]="selectAllServiceChecked"
            (change)="onSelectAllService($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            <span class="checkBoxSpan">
              {{ 'Select_All_Service' | translate }}
            </span>
          </mat-checkbox>
        </div>
      </div>
  
      <div class="services-list" *ngIf="!servicesLoading; else servicesSkeleton">
        <div
          class="service-row"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          *ngFor="let service of servicesList"
        >
          <div class="bt-1">
            <mat-checkbox
              class="terms-conditions"
              color="primary"
              [checked]="service.checked"
              [(ngModel)]="service.checked"
              (change)="onChangeServiceCheckBox(service)"
              [ngModelOptions]="{ standalone: true }"
            >
              <span class="checkBoxSpan">{{ service.GlobalName }}</span>
            </mat-checkbox>
          </div>
          <div
            class="stepper-input"
            [class.has-error]="hasServicePriceError(service)"
          >
            <button
              type="button"
              class="stepper-btn minus-btn"
              [disabled]="!service.checked"
              (click)="decrementServicePrice(service)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
              </svg>
            </button>
            <span CurrencySvg></span>
            <input
              type="number"
              class="stepper-value"
              min="1"
              [disabled]="!service.checked"
              [ngModel]="service.ServicePrice ?? null"
              (ngModelChange)="onStepperValueChange(service, $event)"
              [ngModelOptions]="{ standalone: true }"
              appNumberOnly
            />
            <button
              type="button"
              class="stepper-btn plus-btn"
              [disabled]="!service.checked"
              (click)="incrementServicePrice(service)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <ng-template #servicesSkeleton>
        <div class="services-skeleton">
          <div class="service-row-skeleton" *ngFor="let i of [1,2,3,4]">
            <div class="skeleton-checkbox"></div>
            <div class="skeleton-stepper"></div>
          </div>
        </div>
      </ng-template>
    </div>
  
    <div
      class="actions-buttons"
      *ngIf="showActions"
      fxLayout="row"
      fxLayoutAlign="stretch center"
      fxLayoutGap="16px"
    >
      <button
        type="button"
        class="action-btn prev-btn"
        fxFlex="1 1 0"
        (click)="onCancelClick()"
      >
        {{ cancelLabelKey | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        class="action-btn submit-btn"
        fxFlex="1 1 0"
        type="button"
        [disabled]="!canConfirm || loading"
        (click)="onSubmit()"
      >
        {{ submitLabelKey | translate }}
        <span class="btn-spinner-icon" *ngIf="loading"></span>
      </button>
    </div>
  </div>
</form>
